import { GetStaticPaths, GetStaticProps } from 'next'

import { Article } from 'api'
import {
  articleStaticPropsFunc,
  articleStaticPathsFunc,
} from 'sections/articles/page-reusable-data/funcs'
import { ArticlePageMain } from 'sections/articles/page-reusable-data/article'

interface Props {
  article: Article
}

export const getStaticProps: GetStaticProps<Props> = async (context) => {
  return await articleStaticPropsFunc(context)
}

export const getStaticPaths: GetStaticPaths = async () => {
  return await articleStaticPathsFunc({})
}

export default function ArticlePage({ article }: Props) {
  return <ArticlePageMain article={article} />
}

ArticlePage.layoutProps = {}
